"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconOnePlatform = function SvgIconOnePlatform(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "one platform icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'One Platform Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 8h28.5A1.5 1.5 0 0142 9.5V32a1.5 1.5 0 01-1.5 1.5h-12v3H33v3H21v-3h4.5V26H39V11H10.5V9.5A1.5 1.5 0 0112 8zm7.5 19.5v6H21c1.654 0 3-1.346 3-3v-15c0-1.655-1.346-3-3-3H10.5c-1.655 0-3 1.345-3 3V20h3v-1.5H21v9h-1.5zm-1.504-3.15A3.003 3.003 0 0015 21.5H9l-.15.004A3.003 3.003 0 006 24.5v12l.004.15A3.003 3.003 0 009 39.5h6l.15-.004A3.003 3.003 0 0018 36.5v-12l-.004-.15zM9 24.5h6l.002 7.5H9v-7.5z"
  }));
};

var _default = SvgIconOnePlatform;
exports.default = _default;